import api from "./api";

export function listarPostsPublicos() {
  return api.get("/blog").then((response) =>
    Array.isArray(response.data) ? response.data : [],
  );
}

export function buscarPostPublico(idOrSlug) {
  return api
    .get(`/blog/${encodeURIComponent(idOrSlug)}`)
    .then((response) => response.data);
}

export function listarPostsAdmin() {
  return api.get("/blog/admin/all").then((response) =>
    Array.isArray(response.data) ? response.data : [],
  );
}

export function buscarPostAdmin(id) {
  return api.get(`/blog/admin/${id}`).then((response) => response.data);
}

export function criarPost(payload) {
  return api.post("/blog", payload).then((response) => response.data);
}

export function atualizarPost(id, payload) {
  return api.put(`/blog/${id}`, payload).then((response) => response.data);
}

export function publicarPost(id) {
  return api.patch(`/blog/${id}/publish`).then((response) => response.data);
}

export function ocultarPost(id) {
  return api
    .patch(`/blog/${id}/hide`, { confirm: true })
    .then((response) => response.data);
}

export function reexibirPost(id) {
  return api.patch(`/blog/${id}/unhide`).then((response) => response.data);
}

export function excluirPost(id) {
  return api
    .delete(`/blog/${id}`, { data: { confirm: true } })
    .then((response) => response.data);
}

export function enviarImagem(file) {
  const formData = new FormData();
  formData.append("image", file);

  return api
    .post("/media/upload", formData)
    .then((response) => response.data);
}

export function removerImagem(publicId) {
  return api
    .delete("/media/remove", { data: { public_id: publicId } })
    .then((response) => response.data);
}
